module.exports = __webpack_public_path__ + "img/student.db6e9822.png";